<div class="dashboard--module-header">
    <h2 class="subheading-sm">Total Portfolio Credit Status <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<cumulative-credit-status-chart [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData" class="module--main"></cumulative-credit-status-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>

